import { WEALTH_ROUTES } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import { ChevronRightIcon } from '@heroicons/react/16/solid'
import { type FC } from 'react'

const ActivateCardAttribute: FC<{
  cardId: string
  alias: number
}> = ({ alias }) => {
  const { t } = useTranslation('features-account')

  return (
    <a
      href={WEALTH_ROUTES.CHECKING_ACCOUNT_DEBIT_CARD_ACTIVATE.path.replace(':alias', alias.toString())}
      id="reportCardAttribute"
      className="!text-base max-md:px-2 group py-4 border-b transition-all duration-200 cursor-pointer border-light flex justify-between"
    >
      <p className="flex-1">{t('debit_card.activate_physical_card')}</p>
      <ChevronRightIcon className="fill-iconmuted md:group-hover:fill-iconfull h-6 w-6 stroke-none" />
    </a>
  )
}

export default ActivateCardAttribute
